import React from 'react';
import Alert from 'react-bootstrap/Alert';
import USMap from '../SubcontractorRegistration/USMap';

const STATE_NAMES = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia',
  FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois',
  IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana',
  ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota',
  MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada',
  NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York',
  NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon',
  PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota',
  TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia',
  WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
};

function ServiceAreasStep({ selectedStates, error, onChange }) {
  const handleStateClick = (stateCode) => {
    if (selectedStates.includes(stateCode)) {
      onChange(selectedStates.filter((s) => s !== stateCode));
    } else {
      onChange([...selectedStates, stateCode]);
    }
  };

  const handleRemoveState = (stateCode) => {
    onChange(selectedStates.filter((s) => s !== stateCode));
  };

  const handleSelectAll = () => {
    onChange(Object.keys(STATE_NAMES));
  };

  const handleClearAll = () => {
    onChange([]);
  };

  return (
    <div className="service-areas-step">
      <h5 className="mb-3">Service Areas</h5>
      <p className="text-muted mb-4">
        Click on the states where your business can and will operate. You can select multiple states.
      </p>

      {error && <Alert variant="danger">{error}</Alert>}

      <div className="d-flex gap-2 mb-3">
        <button type="button" className="btn btn-outline-success btn-sm" onClick={handleSelectAll}>
          Select All
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={handleClearAll}
          disabled={selectedStates.length === 0}
        >
          Clear All
        </button>
      </div>

      <div className="us-map-container mb-4">
        <USMap selectedStates={selectedStates} onStateClick={handleStateClick} selectedColor="#198754" />
      </div>

      {selectedStates.length > 0 && (
        <div className="selected-states">
          <h6 className="mb-2">Selected Service Areas ({selectedStates.length}):</h6>
          <div className="selected-states-list">
            {selectedStates.sort().map((code) => (
              <span key={code} className="state-pill" style={{ backgroundColor: '#198754' }}>
                {STATE_NAMES[code]}
                <button
                  type="button"
                  onClick={() => handleRemoveState(code)}
                  aria-label={`Remove ${STATE_NAMES[code]}`}
                >
                  &times;
                </button>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ServiceAreasStep;
